import { addDays } from './dates.ts';

export function isSessionExpired(date, days, { currentDate = new Date() } = {}) {
  const inDays = sessionExpires(days);
  if (inDays === 0) return false;
  return addDays(date, inDays) <= currentDate;
}

export function sessionExpires(days) {
  if (!days) return 0;

  let inDays;
  if (typeof days === 'object' && 'sessionExpires' in days) {
    inDays = days.sessionExpires;
  } else {
    inDays = days;
  }
  return inDays || 0;
}
